import type { FC } from 'react';
import { Navigate, useParams } from 'react-router';
import { useAccountDetails } from '../api';
import AccountForm from './AccountForm';
import FormSkeleton from './FormSkeleton';
import { SuspenseBoundary } from 'components/common';

const EditAccountComponent: FC = () => {
  const { accountId } = useParams();
  const { data } = useAccountDetails({ params: { id: Number(accountId) } });

  if (!accountId) return <Navigate to={'/'} />;
  return <AccountForm data={data} />;
};

const EditAccount: FC = () => {
  return (
    <SuspenseBoundary fallback={<FormSkeleton />}>
      <EditAccountComponent />
    </SuspenseBoundary>
  );
};

export default EditAccount;
